<template>
	<div
		v-if="filters"
		class="products__categories-item"
	>
		<a
			class="products__categories-item-link products-filter__trigger"
			href="javascript:void()"
			@click.prevent="toggleOverlay"
		>
			<div class="products__categories-item-inner">
				<span
					class="products__categories-item-badge"
					v-html="filtersActive.length"
					v-if="filtersActive.length"
				/>
				<SVGFilter
					class="products__categories-item-icon"
				/>
				<span
					class="products__categories-item-text products__categories-item-text--main"
					v-html="$t('shoplist.filter.iconLabel')"
				/>
			</div>
		</a>
		<div
			class="products-filter"
		>
			<div class="products-filter__wrapper">
				<div class="products-filter__header">
					<h3
						class="products-filter__title"
						v-html="$t('shoplist.filter.title')"
					/>
					<button
						class="products-filter__close"
						@click.prevent="closeOverlay"
					>
						<SVGClose/>
					</button>
				</div>

				<div
					class="products-filter__group"
					v-for="filter in filtersEnhanced"
					:key="filter.title"
				>
					<h4
						class="products-filter__group-title"
						v-html="filter.title"
					/>
					<label
						class="products-filter__option"
						v-for="option in filter.options"
						:key="option.id"
					>
						<input
							type="checkbox"
							class="products-filter__option-input"
							v-model="filterStates[option.id]"
						>
						<span
							class="products-filter__option-label"
							v-html="option.label || option.id"
						/>
					</label>
				</div>
				<div
					v-if="!filters.length"
					class="products-filter__empty"
					v-html="$t('shoplist.filter.empty')"
				/>
				<Button
					v-if="filters.length"
					class="products-filter__apply"
					:text="$t('shoplist.filter.applyButton')"
					type="button"
					level="primary"
					@click.prevent="onApplyFilters"
					block
					small
					:disabled="loading"
				/>
				<Button
					v-if="hasActiveFilters || filtersActive.length"
					class="products-filter__reset"
					:text="$t('shoplist.filter.resetButton')"
					type="button"
					level="tertiary"
					arrow
					@click.prevent="onResetFilters"
					:disabled="loading"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex'
import htmlComponent from 'htmlcomponent'
import GenericMixin from '@/mixins/GenericVueMixin';
import OverlayMixin from '@/mixins/OverlayVueMixin';
import Button from '@/components/Button';

export default {
	mixins: [
		GenericMixin,
		OverlayMixin,
	],
	components: {
		Button
	},
	props: {
		overlayType: {
			type: String,
			default: 'products-filter'
		},
		filters: {
			type: Array,
			default: []
		},
		filtersActive: {
			type: Array,
			default: Array,
		}
	},
	data() {
		return {
			opened: false,
			filterStates: {}
		};
	},
	computed: {
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		filtersEnhanced() {
			const filters =  this.filters
				.reduce((p, c) => {
					if (!p[c.group]) {
						p[c.group] = {
							title: c.group,
							options: []
						}
					}
					p[c.group].options.push({...c})
					return p
				}, {})
			return Object.values(filters)
		},
		hasActiveFilters() {
			return Object.values(this.filterStates).some(state => state)
		}
	},
	methods: {
		onApplyFilters() {
			const filters = Object.entries(this.filterStates).map(([filterId, active]) => ({filterId, active}))
			this.$emit('apply', filters);
			this.overlayIgnoreScrollPos = true;
			this.closeOverlay();
		},
		onResetFilters() {
			this.filters.forEach(filter => {
				Vue.set(this.filterStates, filter.id, false);
			})
			this.onApplyFilters();
		},
		beforeOverlayOpen() {
			this.filters.forEach(filter => {
				Vue.set(this.filterStates, filter.id, filter.active);
			})
		},
		afterOverlayClose() {
			this.overlayIgnoreScrollPos = false;
		}
	}
}
</script>

<style>

</style>
